<template>
  <div>
    <div class="banner">
      <h4>{{ resource.profile_user_unities ? "Alterar Vínculo" : "Adicionar Vínculo" }}</h4>
    </div>
    <v-form @submit.prevent="save" ref="form">
      <v-row dense>
        <v-col class="d-flex" cols="12" sm="12" v-if="resource.profile_user_unities">
          <v-radio-group v-model="selectedProfile" row dense :rules="formRules">
            <p class="mb-1" style="width: 100%">
              Qual Perfil deseja alterar?<span style="color: red">*</span>
            </p>

            <v-radio
              v-for="(perfil, index) in resource.profile_user_unities"
              :key="index"
              :label="perfil.profile.name"
              :value="perfil.profile_id"
              color="#086318"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-autocomplete
            :rules="perfilRules"
            :items="unidades"
            v-model="linkForm.unity_id"
            item-text="hospital"
            item-value="id"
            dense
            outlined
            color="#41916b"
            class="rounded-lg"
            label="Unidade"
            :disabled="isProfileDisabled"
          >
            <template v-slot:label>
              Unidade <span style="color: red">*</span>
            </template>
          </v-autocomplete>

        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-autocomplete
            :rules="perfilRules"
            :items="perfis"
            v-model="linkForm.profile_id"
            item-text="name"
            item-value="id"
            dense
            outlined
            color="#41916b"
            class="rounded-lg"
            :disabled="isProfileDisabled"
          >
            <template v-slot:label>
              Perfil <span style="color: red">*</span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-card-actions class="cardFooter">
        <v-spacer></v-spacer>
        <v-btn
          class="rounded-lg"
          color="#e74c3c"
          text
          elevation="0"
          @click="$emit('closeDialog'), (linkForm = {}), $refs.form.reset()"
        >
          <span>{{$t('buttons.cancel')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" elevation="0" v-if="selectedProfile" :color="isProfileDisabled ? 'green' : 'red'" @click="enableOrDisableProfile">
            <span class="textBtn">
              {{ enableorDisableButtonDescription }}
            </span>
          </v-btn>
 
        <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :disabled="isProfileDisabled">
          <span class="textBtn">{{
            resource.profile_user_unities ? "Salvar alterações" : "Salvar"
          }}</span>
          <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import axios from "@/axios";
export default {
  data() {
    return {
      perfilRules: [(v) => !!v || "O campo Perfil é obrigatório"],
      formRules: [(v) => !!v || "O campo Perfil é obrigatório"],
      perfis: [],
      unidades: [],
      linkForm: {
         unity_id: null,
         profile_id: null,
      },
      selectedProfile: null,
      enableorDisableButtonDescription: "",
      isProfileDisabled: false,
    };
  },

  props: {
    resource: {
      type: Object,
    },
    resourceVinculoItem: {
      type: Object,
    },
  },

  watch: { 
    selectedProfile(profileId) {
      if (!profileId) return;

      this.applyVinculo(profileId);
      this.handleProfileStatus(profileId);
    },

    unidades(newVal) {
      if (!newVal?.length || !this.selectedProfile) return;
      this.applyVinculo(this.selectedProfile);
      //Se as unidades carregarem 
      // depois do perfil, reaplique o vínculo
    },
  },

  created() {
    this.getFields();
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    getFields() {
      axios.get(`/profiles`).then((response) => {
        this.perfis = response.data.data;
      });
      axios.get(`/unities`).then((response) => {
        this.unidades = response.data.data;
      });
    },

    applyVinculo(profileId) { 
      if (!profileId || !this.unidades.length) return;

      const vinculo = this.resource.profile_user_unities?.find(
        (v) => Number(v.profile_id) === Number(profileId)
      );

      if (!vinculo) return;
      this.$nextTick(() => {
      // perfil
      this.linkForm.profile_id = Number(vinculo.profile_id);
      // unidade 
      this.linkForm.unity_id = Number(vinculo.user_unity.unity_id);
       });
    },

    handleProfileStatus(profileId) {
      const vinculo = this.resource.profile_user_unities?.find(
        v => Number(v.profile_id) === Number(profileId)
      );

      if (!vinculo) return;

      if (vinculo.deleted_at) { 
        this.enableorDisableButtonDescription = "Reativar perfil";
        this.isProfileDisabled = true;
      } else { 
        this.enableorDisableButtonDescription = "Inativar perfil";
        this.isProfileDisabled = false;
      }
    },

    save() {  
      if (this.$refs.form.validate()) {
        let data = {};
        let userData = this.$route.query.item;

        const id = this.resource.user_id ? this.resource.user_id : this.resource.id;
        let vinculos = [];
        //cadastro
        vinculos.push({
          unity_id: this.linkForm.unity_id,
          profile_id: this.linkForm.profile_id,
        });

        if (this.resource.profile_user_unities) {
          vinculos = [];
          //edição
          const selectedProfileId = this.selectedProfile;

          let profile_user_unity_id = this.resource.profile_user_unities.find(
            (profile) => profile.profile_id == selectedProfileId
          );
          vinculos.push({
            unity_id: this.linkForm.unity_id,
            profile_id: this.linkForm.profile_id,
            profile_user_unity_id: profile_user_unity_id.id,
          });

          data = {
            name: userData.name,
            sex_id: userData.sex_id,
            cpf: userData.cpf,
            telephone: userData.telephone,
            email: userData.email,
            crm: null,
            vinculos: vinculos,
          };
        } else {
          data = {
            vinculos: vinculos,
          };
        }

        axios({
         method: this.resource.profile_user_unities ? 'PUT' : 'PATCH',
                url: this.resource.profile_user_unities ? `/users/${id}` : `/users/link/userUnityProfile/${id}`,
                data: data,
        })
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
              this.$emit("closeDialog");
              this.linkForm = {};
              this.$refs.form.reset();
              this.closeSnackBar();
              this.$router.push("/usuarios");
            }, 3000);
          })
          .catch((err) => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: err.erro,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    getSelectedVinculo() {
      return this.resource.profile_user_unities?.find(
        v => Number(v.profile_id) === Number(this.selectedProfile)
      );
    },

    enableOrDisableProfile() {
      const vinculo = this.getSelectedVinculo();

      if (!vinculo) return;

      const isInactive = !!vinculo.deleted_at;

      const profileUserUnityId = vinculo.id;

        axios({
         method: isInactive ? 'PUT' : 'DELETE',
          url: isInactive ? `/users/userUnityProfile/restore/${profileUserUnityId}` : `/users/userUnityProfile/${profileUserUnityId}`
        }).then((response) => {
            vinculo.deleted_at = isInactive ? null : new Date();

            this.handleProfileStatus(this.selectedProfile);

            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message || "Perfil atualizado com sucesso",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });
        })
        .catch((err) => { 
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Erro ao atualizar perfil",
            bodyMessage: err.details ,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        });
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
<style scoped>
.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #41916b, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #41916b, #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner > h4 {
  color: #ffffff;
  padding: 10px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
</style>
